declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'
import { version } from 'xlsx/types';


export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};

export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};

export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: '首页' }, name: 'home', component: () => import('../views/home/home.vue') },
    ]
}
export const takephoneDisplayRoute: Router = {
    path: '/takephone',
    name: 'photograph',
    meta: {
        title: '手机拍照上传图片'
    },
    component: main,
    children: [
        { path: 'uploadpackageimg', meta: { title: '上传打包图片' }, name: 'uploadpackageimg', component: () => import('../views/back/photograph/uploadpackage-scan.vue') },
        { path: 'logisticsphoto', meta: { title: '快递入库照片' }, name: 'logisticsphoto', component: () => import('../views/back/photograph/uploadintologisitics-photo.vue') },
        { path: 'abnormalphoto', meta: { title: '异常订单照片' }, name: 'abnormalphoto', component: () => import('../views/back/photograph/uploadabnormal-photo.vue') }

    ]
};
export const frontDisplayRoute: Router = {
    path: '/frontDisplay',
    name: 'front',
    meta: {
        title: '跨境订单管理'
    },
    component: main,
        children: [
            { path: 'orderDetail', meta: { title: '跨境订单详情' }, name: 'frontDetail', component: () => import('../views/front/order/edit-order.vue') },
            { path: 'stockorderDetail', meta: { title: '库存订单详情' }, name: 'stockorderDetail', component: () => import('../views/front/stock/edit-stockorder.vue') },
            { path: 'abroadorderDetail', meta: { title: '海外订单详情' }, name: 'abroadorderDetail', component: () => import('../views/front/abroad/edit-abroadorder.vue') },
    ]
};
export const mainlandfrontDisplayRoute: Router = {
    path: '/frontmainlandDisplay',
    name: 'front',
    meta: {
        title: '本土订单管理'
    },
    component: main,
    children: [
        { path: 'frontmainlandorderDetail', meta: { title: '本土订单详情' }, name: 'frontmainlandorderDetail', component: () => import('../views/front/order/edit-mainlandorde.vue') }
    ]
};
//export const frontAuthorizationCancelRoute: Router = {
//    path: '/frontauthorization',
//    name: 'authorizationshops',
//    meta: {
//        title: '授权店铺管理'
//    },
//    component: main,
//    children: [
//        {
//            path: 'success', meta: { title: '授权成功' }, name: 'success', component: () => import('../views/front/authorizationshop/authorization-success.vue')
//        }
//        ,
//        {
//            path: 'cancel', meta: { title: '取消授权' }, name: 'cancel', component: () => import('../views/front/authorizationshop/authorizationshop-cancel.vue')
//        }
//    ],
//};


export const shopdetailDisplayRoute: Router = {
    path: '/shopdetailDisplay',
    name: 'shopdetailDisplay',
    meta: {
        title: '商品详情'
    },
    component: main,
    children: [
        { path: 'goodsdetail', meta: { title: '商品详情' }, name: 'goodsdetail', component: () => import('../views/front/distributionshop/shopgoodsdetail.vue') },
        //{
        //    path: 'shoppingcart', permission: '', meta: { title: '购物车' }, name: 'shoppingcart', component: () => import('../views/front/shop/shoppingcart.vue')

        //},
    ]
};
export const editProductDetailRoute: Router = {
    path: '/editproductdetail',
    name: 'editproductdetail',
    meta: {
        title: '商品详情'
    },
    component: main,
    children: [
        { path: 'editdetail', meta: { title: '商品详情' }, name: 'editdetail', component: () => import('../views/back/distributionshop/back-editproductdetail.vue') },
        //{
        //    path: 'shoppingcart', permission: '', meta: { title: '购物车' }, name: 'shoppingcart', component: () => import('../views/front/shop/shoppingcart.vue')

        //},
    ]
};
export const appRouters: Array<Router> = [
    {
    path: '/setting',
    name: 'setting',
    permission: 'Pages.Users',
    meta: { title: '设置' },
    icon: '&#xe68a;',
    component: main,
    children: [
        { path: 'role', permission: 'Pages.Roles', meta: { title: '权限管理' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
    //    { path: 'tenant', permission: 'Pages.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') }
        { path: 'user', permission: 'Pages.Users', meta: { title: '用户管理' }, name: 'user', component: () => import('../views/setting/user/user.vue') },
       { path: 'group', permission: 'Pages.Users', meta: { title: '分组管理' }, name: 'group', component: () => import('../views/setting/group/group.vue') },
    ]
},
    {
        path: '/front',
        name: 'front',
        permission: '',
        meta: { title: '订单管理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            { 
                path: 'order', meta: { title: '创建跨境订单' },  name: 'createOrder', component: () => import('../views/front/order/create-order.vue'),
            },
            {
                path: 'orderList', meta: { title: '跨境订单列表' }, name: 'orderList', component: () => import('../views/front/order/order-list.vue')
            },
            {
                path: 'mainlandfreightcalculation', meta: { title: '本土运费试算' }, name: 'mainlandfreightcalculation', component: () => import('../views/setting/warehouse/front-mainlandfreight.vue')
            },
            {
                path: 'mainlandorder',  meta: { title: '创建本土订单' }, name: 'mainlandorder', component: () => import('../views/front/order/create-mainlandorder.vue'),
            },
            {
                path: 'mainlandorderlist',  meta: { title: '本土订单列表' }, name: 'mainlandorderlist', component: () => import('../views/front/order/mainlandorder-list.vue')
            },
            {
                path: 'frontadvance', meta: { title: '提前录入订单列表' }, name: 'frontadvance', component: () => import('../views/front/order/front-advanceorder-list.vue')
            },
            {
                path: 'frontabnormalreceivingorder', meta: { title: '异常收货订单' }, name: 'frontabnormalreceivingorder', component: () => import('../views/front/order/frontabnormalreceivingorder-list.vue')
            },
            {
                path: 'frontorderReturn', meta: { title: '虾皮订单退回管理' }, name: 'frontorderReturn', component: () => import('../views/front/order/front-orderreturn-list.vue')
            },
            {
                path: 'expressUserInfo', meta: { title: '用户快递信息' }, name: 'expressUserInfo', component: () => import('../views/front/logistics/user-expressinfo.vue')
            },
            {
                path: 'expressrejectionreturn', meta: { title: '拒收/退货申请' }, name: 'expressrejectionreturn', component: () => import('../views/front/logistics/expressrejection-list.vue')
            }
        ]
    },
    {
        path: '/frontabroad',
        name: 'frontabroad',
        permission: '',
        meta: { title: '海外仓管理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            
            {
                path: 'createabroadorder', meta: { title: '创建海外订单' }, name: 'createabroadorder', component: () => import('../views/front/abroad/create-abroadorder.vue')
            },
            {
                path: 'frontabroadorder', meta: { title: '海外订单管理' }, name: 'frontabroadorder', component: () => import('../views/front/abroad/front-abroadorder.vue')
            },
            {
                path: 'createabroadreturnorder', meta: { title: '创建海外退件订单' }, name: 'createabroadreturnorder', component: () => import('../views/front/abroad/create-abroadreturnorder.vue')
            },
            {
                path: 'fontstockreturnorder', meta: { title: '海外退件存储订单' }, name: 'fontstockreturnorder', component: () => import('../views/front/abroad/font-stockreturnorder.vue')
            },
            {
                path: 'fontoverseasreturnorders', meta: { title: '海外退件订单管理' }, name: 'fontoverseasreturnorders', component: () => import('../views/front/abroad/font-overseasreturnorder.vue')
            },
        ]
    },
    {
        path: '/frontstock',
        name: 'frontstock',
        permission: '',
        meta: { title: '库存管理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'stocklist', meta: { title: '入库管理' }, name: 'stocklist', component: () => import('../views/front/stock/front-stock.vue')
            },  
            {
                path: 'frontstockproduct', meta: { title: '产品管理' }, name: 'frontstockproduct', component: () => import('../views/front/stock/front-stockproduct.vue')
            },
            {
                path: 'frontlistedhistory', meta: { title: '上架历史' }, name: 'frontlistedhistory', component: () => import('../views/front/stock/front-listedhistory.vue')
            },
            {
                path: 'createstockorder', meta: { title: '创建囤货订单' }, name: 'createstockorder', component: () => import('../views/front/stock/create-stockorder.vue')
            },
            {
                path: 'frontstockorder', meta: { title: '囤货订单管理' }, name: 'frontstockorder', component: () => import('../views/front/stock/front-stockorder.vue')
            },
        ]
    },
    {
        path: '/back',
        name: 'back',
        permission: 'Order.Manages',
        meta: { title: '订单处理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            //
            {
                path: 'backOrderList', permission: 'OrderManage.CrossOrderManage', meta: { title: '跨境订单列表' }, name: 'backOrderList', component: () => import('../views/back/order/order-list.vue')
            },
            {
                path: 'backmainlandOrderList', permission: 'OrderManage.MainLandOrderManage', meta: { title: '本土订单列表' }, name: 'backmainlandOrderList', component: () => import('../views/back/order/mainlandorder-list.vue')
            },
            {
                path: 'backadvance', permission:  'OrderManage.MainLandOrderManage', meta: { title: '提前录入订单列表' }, name: 'backadvance', component: () => import('../views/back/order/back-advanceorder-list.vue')
            },
            //{
            //    path: 'backynrefusal', permission: 'OrderManage.MainLandOrderManage', meta: { title: '云南拒收订单列表' }, name: 'backynrefusal', component: () => import('../views/back/order/back-ynrefusalorder-list.vue')
            //},
            {
                path: 'mainlandpackageList', permission: 'OrderManage.MainLandOrderManage', meta: { title: '本土包裹列表' }, name: 'mainlandpackageList', component: () => import('../views/back/order/mainlandpackage-list.vue')
            },
            {
                path: 'thirdparty', permission: 'OrderManage.MainLandOrderManage', meta: { title: '配置体积重参数' }, name: 'thirdparty', component: () => import('../views/setting/thirdparty/thirdpartyparameter-list.vue')
            },
            {
                path: 'abnormalreceivingorder', permission: 'Order.Manages', meta: { title: '异常收货订单' }, name: 'abnormalreceivingorder', component: () => import('../views/back/order/abnormalreceivingorder-list.vue')
            },
            {
                path: 'logisticsList', permission: 'OrderManage.MainLandOrderManage', meta: { title: '快递管理' }, name: 'logisticsList', component: () => import('../views/back/logistics/logistics-list.vue')
            },
            {
                path: 'signlogisticsList', permission: 'Order.Manages', meta: { title: '快递签收管理' }, name: 'signlogisticsList', component: () => import('../views/back/logistics/sign-logistics-list.vue')
            },
            {
                path: 'returnrejection', permission: 'OrderManage.MainLandOrderManage', meta: { title: '拒收/退货处理' }, name: 'returnrejection', component: () => import('../views/back/logistics/returnrejectioninfo-list.vue')
            },
            {
                path: 'expressImport', permission: 'Express.Import', meta: { title: '快递导入管理' }, name: 'expressImport', component: () => import('../views/back/logistics/express-import.vue')
            },
            {
                path: 'orderReturn', permission: 'Order.Manages', meta: { title: '虾皮订单退回管理' }, name: 'orderReturn', component: () => import('../views/back/order/orderreturn-list.vue')
            },
            {
                path: 'expressphoto', permission: 'Order.Manages', meta: { title: '快递拍照' }, name: 'expressphoto', component: () => import('../views/back/logistics/express-photo.vue')
            },
            {
                path: 'orderScan', permission: 'Order.Manages', meta: { title: '扫描送仓' }, name: 'orderScanMenu', component: () => import('../views/back/order/order-scan.vue')
            },
            {
                path: 'weightScan', permission: 'Order.Manages', meta: { title: '扫描商品称重' }, name: 'weightScan', component: () => import('../views/back/order/weight-scan.vue')
            },
            {
                path: 'intoLogistics', permission: 'OrderManage.ExpressShipmentDelivery', meta: { title: '快递单号入库' }, name: 'intoLogistics', component: () => import('../views/back/logistics/into-logistick-check.vue')
            },
            {
                path: 'intologisticsrecord', permission: 'Order.Manages', meta: { title: '检查快递单号入库记录' }, name: 'intologisticsrecord', component: () => import('../views/back/logistics/intologisticsrecord-list.vue')
            },
        ]
    },
    {
        path: '/backabroad',
        name: 'backabroad',
        permission: 'warehouse.Stock',
        meta: { title: '海外仓处理' },
        icon: '&#xe68a;',
        component: main,
        children: [

            {
                path: 'backabroadlogistics', permission: 'warehouse.Stock', meta: { title: '海外订单快递管理' }, name: 'backabroadlogistics', component: () => import('../views/back/abroad/back-abroadlogistics.vue')
            },
            {
                path: 'intoabroadLogistics', permission: 'warehouse.Stock', meta: { title: '海外订单快递单号入库' }, name: 'intoabroadLogistics', component: () => import('../views/back/abroad/into-abroadlogistics-check.vue')
            },
            {
                path: 'intoabroadstockreturncheck', permission: 'warehouse.Stock', meta: { title: '海外退件订单入库' }, name: 'intoabroadstockreturncheck', component: () => import('../views/back/abroad/into-abroadstockreturn-check.vue')
            },
            {
                path: 'backabroadorder', permission: 'warehouse.Stock', meta: { title: '海外订单处理' }, name: 'backabroadorder', component: () => import('../views/back/abroad/back-abroadorder.vue')
            },
            //{   
            //    path: 'backstockreturnorder', permission: 'warehouse.Stock', meta: { title: '海外退件存储订单' }, name: 'backstockreturnorder', component: () => import('../views/back/abroad/back-stockreturnorder.vue')
            //},
            {
                path: 'backoverseasreturnorder', permission: 'warehouse.Stock', meta: { title: '海外退件管理订单' }, name: 'backoverseasreturnorder', component: () => import('../views/back/abroad/back-overseasreturnorder.vue')
            },
            {
                path: 'overseasbasecost', permission: 'warehouse.Stock', meta: { title: '海外仓基本费用设置' }, name: 'overseasbasecost', component: () => import('../views/back/abroad/overseas-basecostsetting.vue')
            },
            {
                path: 'backrefusalorder', permission: 'warehouse.Stock', meta: { title: '海外拒收订单处理' }, name: 'backrefusalorder', component: () => import('../views/back/abroad/back-refusalorder-list.vue')
            },
            {   
                path: 'backstockreturnorder', permission: 'warehouse.Stock', meta: { title: '海外退件存储订单' }, name: 'backstockreturnorder', component: () => import('../views/back/abroad/back-stockreturnorder.vue')
            },
            {
                path: 'backoverseasreturnhandle', permission: 'warehouse.Stock', meta: { title: '海外拒收/退货处理' }, name: 'backoverseasreturnhandle', component: () => import('../views/back/abroad/back-overseasreturnhandle.vue')
            },

        ]
    },
    {
        path: '/backstock',
        name: 'backstock',
        permission: 'warehouse.Stock',
        meta: { title: '库存处理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            
            {
                path: 'backstockList', permission: 'warehouse.Stock', meta: { title: '入库处理' }, name: 'backstockList', component: () => import('../views/back/stock/backstock-list.vue')
            },
            {
                path: 'backstockproduct', permission: 'warehouse.Stock', meta: { title: '产品处理' }, name: 'backstockproduct', component: () => import('../views/back/stock/back-stockproduct.vue')
            },
            {
                path: 'backstockorder', permission: 'warehouse.Stock', meta: { title: '囤货订单处理' }, name: 'backstockorder', component: () => import('../views/back/stock/back-stockorder.vue')
            },
            {
                path: 'backlistedhistory', permission: 'warehouse.Stock', meta: { title: '上架历史' }, name: 'backlistedhistory', component: () => import('../views/back/stock/back-listedhistory.vue')
            },


        ]
    },
    //{
    //    path: '/authorizationshops',
    //    name: 'authorizationshops',
    //    meta: { title: '授权店铺管理' },
    //    icon: '&#xe68a;',
    //    component: main,
    //    children: [
    //        {
    //            path: 'authorizationshoplist', meta: { title: '授权店铺信息' }, name: 'authorizationshoplist', component: () => import('../views/front/authorizationshop/authorizationshop-list.vue')
    //        },

    //    ]
    //},
    {
        path: '/frontdistributionshop',
        name: 'frontdistributionshop',
        permission: '',
        meta: { title: '分销商城' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'frontdistributionproduct', meta: { title: '产品管理' }, name: 'frontdistributionproduct', component: () => import('../views/front/distributionshop/front-distributionproduct-list.vue')
            },
            {
                path: 'frontdistributionorderlist', meta: { title: '订单管理' }, name: 'frontdistributionorderlist', component: () => import('../views/front/distributionshop/front-distributionorder-list.vue')
            },
        ]
    },
    {
        path: '/backdistributionshop',
        name: 'backdistributionshop',
        permission: 'warehouse.Stock',
        meta: { title: '分销商城处理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'backdistributionproduct', permission: 'warehouse.Stock', meta: { title: '产品管理' }, name: 'backdistributionproduct', component: () => import('../views/back/distributionshop/back-distributionproduct-list.vue')
            },
            {
                path: 'backdistributionorderlist', permission: 'warehouse.Stock', meta: { title: '订单处理' }, name: 'backdistributionorderlist', component: () => import('../views/back/distributionshop/back-distributionorder-list.vue')
            },
        ]
    },
    {
        path: '/amount',
        name: 'amount',
        permission: '',
        meta: { title: '积分管理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'recharge', meta: { title: '在线充值' }, name: 'recharge', component: () => import('../views/front/amount/recharge.vue')
            },
            {
                path: 'amountList', meta: { title: '消费明细' }, name: 'amountList', component: () => import('../views/front/amount/amount-list.vue')
            },
            {
                path: 'fontamountFlowStatistical', meta: { title: '消费统计' }, name: 'fontamountFlowStatistical', component: () => import('../views/front/statisticalrecords/fontamount-flow-statistical-list.vue')
            }
        ]
    },
    {
        path: '/back',
        name: 'backs',
        permission: 'Amount.Manages',
        meta: { title: '用户积分管理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'flow', permission: 'Amount.Manages',meta: { title: '消费流水' }, name: 'flow', component: () => import('../views/back/amountflow/flow-list.vue')
            }
        ]
    },
    {
        path: '/backStatistical',
        name: 'backStatisticals',
        permission: 'Statistical.Manages',
        meta: { title: '统计记录' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'packstatistical', permission: 'Statistical.Manages', meta: { title: '打包数量统计' }, name: 'packstatistical', component: () => import('../views/back/statisticalrecords/packstatistical-list.vue')
            },
            {
                path: 'signforLogisticsStatistical', permission: 'Statistical.Manages', meta: { title: '快递入库统计' }, name: 'signforLogisticsStatistical', component: () => import('../views/back/statisticalrecords/signfor-logitics-statistical-list.vue')
            },
            {
                path: 'amountFlowStatistical', permission: 'Statistical.Manages', meta: { title: '消费流水统计' }, name: 'amountFlowStatistical', component: () => import('../views/back/statisticalrecords/amount-flow-statistical-list.vue')
            }
        ]
    },
    {
        path: '/warehousestore',
        name: 'warehousestore',
        permission: 'warehouse.Manages',
        meta: { title: '仓储管理' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'backstore', permission: 'warehouse.Manages', meta: { title: '仓储地址' }, name: 'backstore', component: () => import('../views/back/warehousestore/storeaddress-list.vue')
            },
        ]
    },
    {
        path: '/warehouse',
        name: 'warehouse',
        permission: 'warehouse.Manages',
        meta: { title: '仓库设置' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'mianlandfreight', permission: 'warehouse.Manages', meta: { title: '本土运费' }, name: 'mianlandfreight', component: () => import('../views/setting/warehouse/mainland-freight.vue')
            },
            {
                path: 'basecostsetting', permission: 'warehouse.Manages', meta: { title: '基本费用设置' }, name: 'basecostsetting', component: () => import('../views/setting/warehouse/basecost-setting-list.vue')
            },
        ]
    },
    {
        path: '/courier',
        name: 'courier',
        permission: 'OrderManage',
        meta: { title: '快递入库' },
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'courierExpressDeliveryList', permission: 'Order.Manages', meta: { title: '入库查询' }, name: 'courierExpressDeliveryList', component: () => import('../views/back/courier/courier-express-delivery-list.vue'),
            },
            {
                path: 'courierExpressDeliveryCreate', permission: 'Order.Manages', meta: { title: '新增入库' }, name: 'courierExpressDeliveryCreate', component: () => import('../views/back/courier/courier-express-delivery-create.vue'),
            }
        ]
    }
]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters,
    frontDisplayRoute,
    mainlandfrontDisplayRoute,
  //  frontAuthorizationCancelRoute,
    takephoneDisplayRoute,
    shopdetailDisplayRoute,
    editProductDetailRoute
];
